export default __webpack_public_path__ + "static/media/contextual-chocolate@2x.4c29a3bd.png";